export default {"src":"/_next/static/media/14-morning-brew-logo.0cc19d57.svg","height":24,"width":168};